var render = function render(){var _vm=this,_c=_vm._self._c;return _c('note-editor-window',{attrs:{"opened":_vm.opened,"title":_vm.labels.title,"note":_vm.comment,"limit":2000,"uploader":_vm.uploadCommentFile},on:{"save":_vm.save,"cancel":_vm.cancel}})
}
var staticRenderFns = []

export { render, staticRenderFns }